module.exports = __webpack_public_path__ + "static/media/LV5@3x.b1b6b989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV5@3x.png
// module id = 688
// module chunks = 0